import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getLocalStorage } from "../utils/localStorage";
import { AUTH_TOKEN } from "../utils/constants";

const useAuth = () => {
  const navigate = useNavigate();
  const authToken = getLocalStorage(AUTH_TOKEN);

  useEffect(() => {
    if (!authToken) {
      navigate("/on-boarding");
    }
  }, [authToken, navigate]);

  return authToken;
};

export default useAuth;
